
  import { mapState } from 'vuex'
  import bankAccountDesktop from '~/mixins/common/bank-account-desktop'
  import finance from '~/mixins/common/pages/finance'
  import staticAmount from '~/static/json/amount.json'
  export default {
    mixins: [finance, bankAccountDesktop],
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        steppers: 1,
        amount: '0',
        form: {
          amount: null
        },
        selectedBankId: '',
        valid: true,
        receiverBankInfo: {},
        remainingTime: '--:--',
        countingDownInterval: null,
        nextStepBtnLoading: false,
        cancelBtnLoading: false,
        pleaseSelectedBankId: false,
        reg_flow: 1,
        delay5seconds: false
      }
    },
    computed: {
      ...mapState({
        player: state => state.player.player,
        tempData: state => state.themes.deposit.tempData,
        checkExist: state => state.themes.deposit.checkExist,
        operationSetting: state => state.settings.operationSetting
      }),
      bankData() {
        if (this.receiverBankInfo?.created_at) {
          const info = this.receiverBankInfo
          return {
            reference_id: info?.bank_transaction_id,
            deposit_id: info?.deposit_id,
            bank_name: info?.bank_info?.bank_name,
            bank_branch: info?.bank_info?.bank_branch,
            bank_account_number: info?.bank_info?.bank_account_number,
            bank_account_name: info?.bank_info?.bank_account_name,
            created_at: info?.created_at,
            deposit_amount: info?.deposit_amount
          }
        }
        if (this.tempData.bank_info) {
          return {
            reference_id: this.tempData?.reference_id,
            deposit_id: this.tempData?.deposit_id,
            bank_name: this.tempData?.bank_info?.bank_name,
            bank_branch: this.tempData?.bank_info?.bank_branch,
            bank_account_number: this.tempData?.bank_info?.bank_account_number,
            bank_account_name: this.tempData?.bank_info?.bank_account_name,
            created_at: this.tempData?.created_at,
            deposit_amount: this.tempData?.deposit_amount
          }
        }
        return {}
      },
      formRule() {
        return {
          amount: [
            v => !!v || this.tr(this.FRONTEND_ERROR_CODES.amountIsRequired),
            v =>
              v?.toString()?.replace(/,/g, '') > 0 ||
              this.tr(this.FRONTEND_ERROR_CODES.amountGreaterThanZero),
            v =>
              (v && parseFloat(v?.toString()?.replace(/,/g, ''))) >=
                ~~this.operationSetting?.deposit_min ||
              `${this.tr(this.FRONTEND_ERROR_CODES.minDepositIs)} ${this.formatCurrencyJS(
                this.operationSetting.deposit_min
              )}`,
            v =>
              (v && parseFloat(v?.toString()?.replace(/,/g, ''))) <=
                ~~this.operationSetting?.deposit_max ||
              `${this.tr(this.FRONTEND_ERROR_CODES.maxDepositIs)} ${this.formatCurrencyJS(
                this.operationSetting?.deposit_max
              )}`,
            v =>
              (v && this.decimalRule(v?.toString()?.replace(/,/g, ''))) ||
              this.tr(this.FRONTEND_ERROR_CODES.decimalIsTwoDigit)
          ]
        }
      },
      disableNextButton() {
        if (!this.selectedBankId) return true
        return false
      },
      selectAmount() {
        const res = staticAmount.find(value => value.currency === this.player?.currency || 'THB')
        return res?.amount || []
      }
    },
    watch: {
      checkExist(value) {
        this.receiverBankInfo = {}
        if (value && value.is_exist !== false) {
          this.receiverBankInfo = value
          if (value?.created_at && value.deposit_status === 1) {
            this.steppers = 2
            this.countingDown(value?.created_at)
          } else if ([2, 3, 4].includes(value.deposit_status)) {
            this.steppers = 3
          }
        } else {
          this.steppers = 1
          if (this.countingDownInterval) {
            this.clearTimeout()
          }
        }
      },
      operationSetting(value) {
        this.reg_flow = value?.reg_flow
      }
    },
    beforeDestroy() {
      clearInterval(this.countingDownInterval)
      this.countingDownInterval = null
    },
    methods: {
      countingDown(createdAt) {
        const start = this.$dayjs(createdAt)
        this.countingDownInterval = setInterval(() => {
          const end = this.$dayjs()

          const duration = this.$dayjs.duration(end.diff(start))
          const minutes = duration.minutes().toString().padStart(2, '0')
          const seconds = duration.seconds().toString().padStart(2, '0')

          const currentDuration = this.$dayjs.duration({
            minutes,
            seconds
          })
          const totalDuration = this.$dayjs.duration(10, 'minute')
          totalDuration.subtract(2, 'second')

          const timeLeft = this.$dayjs.duration(totalDuration - currentDuration)

          const minutesLeft = timeLeft.minutes()
          const secondsLeft = timeLeft.seconds()

          if (minutesLeft === 0 && secondsLeft <= 0) {
            this.steppers--
            clearInterval(this.countingDownInterval)
            this.countingDownInterval = null
          }
          if (minutesLeft >= 0 && secondsLeft >= 0) {
            const minutesFormatted = minutesLeft.toString().padStart(2, '0')
            const secondsFormatted = secondsLeft.toString().padStart(2, '0')

            this.remainingTime = `${minutesFormatted}:${secondsFormatted}`
          }
        }, 1000)
      },
      onInputAmount(amount) {
        if (isNaN(amount?.replace(/,/g, ''))) {
          this.form.amount = '0'
          return
        }
        this.amount = amount ? Number.parseFloat(amount?.replace(/,/g, ''))?.toLocaleString() : ''
        this.form.amount = this.amount?.toString()?.replace(/,/g, '')
      },
      formatNumber(number) {
        if (!number) return '0'
        return Number.parseFloat(number?.toString()?.replace(/,/g, ''))?.toLocaleString()
      },
      onSelectStaticAmount(amount) {
        this.amount = amount
          ? Number.parseFloat(amount?.toString()?.replace(/,/g, ''))?.toLocaleString()
          : ''
        this.form.amount = amount?.toString()
      },
      async onNextDeposit() {
        if (this.$refs.form.validate()) {
          // Track Events if not first deposit
          await this.trackDepositEvent(
            this.checkExist.sequence,
            this.form.amount,
            this.selectedBankId
          )

          this.nextStepBtnLoading = true
          if (!this.selectedBankId && [1, 3, 5].includes(this.reg_flow)) {
            this.pleaseSelectedBankId = true
            this.nextStepBtnLoading = false
            return
          }
          this.pleaseSelectedBankId = false
          if (this.selectedBankId) {
            this.form.player_bank_account_id = this.selectedBankId
          } else {
            delete this.form.player_bank_account_id
          }
          const response = await this.$store.dispatch('themes/deposit/create', this.form)
          if (response) {
            this.steppers++
            this.$emit('bankTransferConfirm', true)
            this.countingDown(response.created_at)
            this.delay5seconds = true
            setTimeout(() => {
              this.delay5seconds = false
            }, 5000)
          }
          this.nextStepBtnLoading = false
        }
      },
      async onConfirmDeposit() {
        this.nextStepBtnLoading = true
        const response = await this.$store.dispatch(
          'themes/deposit/confirm',
          this.bankData.deposit_id
        )
        if (response) {
          this.steppers++
        }
        this.nextStepBtnLoading = false
      },
      async onRevokeDeposit() {
        this.cancelBtnLoading = true
        const response = await this.$store.dispatch(
          'themes/deposit/revoke',
          this.bankData.deposit_id
        )
        if (response) {
          this.steppers--
          this.$emit('bankTransferConfirm', false)
          this.clearTimeout()
          this.receiverBankInfo = {}
        }
        this.cancelBtnLoading = false
      },
      clearTimeout() {
        clearInterval(this.countingDownInterval)
        this.countingDownInterval = null
      }
    }
  }
